import { configureStore } from '@reduxjs/toolkit';
import trafficInfraReducer from '../features/trafficInfra/trafficInfraSlice';
import deviceStateReducer from '../features/deviceState/deviceStateSlice';
import tunnelStateReducer from '../features/tunnelState/tunnelStateSlice';
import mapReducer from '../features/map/mapSlice';
import toastReducer from '../features/ui/toastSlice';

export default configureStore({
    reducer: {
        trafficInfra: trafficInfraReducer,
        deviceState: deviceStateReducer,
        tunnelState: tunnelStateReducer,
        map: mapReducer,
        toast: toastReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: { warnAfter: 300 },
            immutableCheck: { warnAfter: 300, ignore: ['trafficInfra'] },
        }),
});
